import React, { useState, useEffect } from 'react';
import { Card, Toast } from 'antd-mobile';
import { TravelOutline } from 'antd-mobile-icons';
import API_ROUTES from '../api';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const GameYear = () => {
    const [gameYearList, setGameYearList] = useState([]);

    const navigate = useNavigate();

    useEffect(() => {
        axios.get(API_ROUTES.gameYear_list, {
            params: {
                status: "0,1",
            }
        })
            .then(function (response) {
                const resultData = response.data.data;
                setGameYearList(resultData);
                Toast.clear();
            })
            .catch(function (error) {
                Toast.show({
                    icon: 'fail',
                    content: '查询失败，请联系管理员！'
                });
            })
            .finally(() => {
                Toast.clear();
            });
    }, []);

    return (
        <div>
            {gameYearList?.length > 0 && (
                <div style={{ width: '100%' }}>
                    {gameYearList.map((item, index) => (
                        <Card
                            key={index}
                            className='home-game-year-card home-card'
                            title={
                                <div className="home-card-title">
                                    <span style={{ fontSize: '14px', color: '#86909C' }}>🎊 年会活动进行中</span>
                                </div>
                            }
                        >
                            <div 
                                className="game-year-title-container" 
                                onClick={() => navigate(`/game-years/${item.id}`)}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="game-year-main-title">
                                    {item.gameName}
                                </div>
                                <div className="game-year-date-box" style={{ marginBottom: '8px' }}>
                                    <div className="game-year-date-tag">
                                        📅 {item.gameTime}
                                    </div>
                                </div>
                            </div>

                            <div className="game-year-location-wrapper" style={{ justifyContent: 'center', background: 'transparent', border: 'none', padding: '4px' }}>
                                <TravelOutline className="text-accent-blue" fontSize={16} />
                                <span style={{ fontSize: '14px', fontWeight: '600', color: '#4E5969' }}>
                                    {item.gameAddress}
                                </span>
                            </div>

                            <div className="game-year-detail-hint">
                                — 点击比赛名称查看详情 —
                            </div>
                        </Card>
                    ))}
                </div>
            )}
        </div>
    );
};

export default GameYear;
